import { useMemo } from 'react'

import { get } from 'lodash'

import { hasBearerToken } from 'common/bearer'
import { useIsAuthed } from 'components/AuthShield'

import { IConfiguration, IUseConfigurationOptions } from './types'

export const useConfiguration = ({ features, permissions }: IUseConfigurationOptions): IConfiguration => {
  /*
    If the user is NOT AUTHED they should get all the features in the student app.
    This is where to change that if it ever becomes not the case anymore.
   */
  const isAuthed = useIsAuthed()
  const hasBearer = hasBearerToken()
  const reallyNotAuthed = !isAuthed && !hasBearer

  const permissionObj = useMemo(() => {
    const obj = {} as Record<string, boolean>
    permissions.forEach((permission) => {
      obj[permission] = true
    })
    return obj
  }, [permissions])

  const configuration: IConfiguration = useMemo(() => {
    const config = {} as IConfiguration
    const featureKeys = Object.keys(features)
    featureKeys.forEach((feature) => {
      const relevantPermissions = get(features, feature, [])
      config[feature] = reallyNotAuthed || relevantPermissions.every((permission: string) => permissionObj[permission])
    })
    return config
  }, [permissionObj, features, reallyNotAuthed])

  return configuration
}
